

document.addEventListener('DOMContentLoaded', function () {

  window.limitPanelQuantity = function () {

    async function fetchWithModernTimeout(url) {
      try {
        // Automatically aborts the request after 5000 milliseconds (5 seconds)
        const response = await fetch(url, {
          signal: AbortSignal.timeout(25000)
        });

        return response;
      } catch (error) {

          console.error('A different network error occurred:', error);
        return { "status": 500 }
      }
    }

    if (customerEmail && (customerEmail.endsWith('@ppg.com') || customerEmail.endsWith('@pittsburghpaints.com'))) {
      console.log('Customer has a PPG email address. Exiting script.');
      return;
    }

    if (hasInfinitePanelsTag) {
      console.log('Customer has InfinitePanels tag. Exiting script.');
      return;
    }

    const panelKeyword = "panel";
    const maxPanels = 10;

    console.log('Script loaded. Checking cart...');

    // Fetch cart details using Shopify's AJAX API
    fetchWithModernTimeout('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart fetched:', cart);

        let panelCount = 0;

        // Loop through cart items to count products whose handle contains "panel"
        cart.items.forEach(item => {
          console.log('Checking item handle:', item.handle);
          if (item.handle.toLowerCase().includes(panelKeyword)) {
            panelCount += item.quantity;
            console.log(`Panel item found: ${item.title} - Quantity: ${item.quantity}`);
          }
        });

        console.log(`Total panel count: ${panelCount}`);

        // Disable the "Checkout" button if the limit is reached (using >= to cap at maxPanels)
        const checkoutButton = document.getElementById('checkout') ||document.getElementById('checkout-button')
        if (panelCount >= maxPanels) {

          if (checkoutButton) {
            console.log('Disabling Checkout button');
            checkoutButton.disabled = true;
            checkoutButton.style.pointerEvents = 'none';

            checkoutButton.textContent = "Panel Limit Exceeded";
          }
        } else {
          console.log('Panel limit not reached, Checkout button remains active.');
          console.log('Disabling Checkout button');
          checkoutButton.disabled = false;
          checkoutButton.style.pointerEvents = 'all';

          checkoutButton.textContent = "Check Out";
        }
      })
      .catch(error => console.error('Error fetching cart:', error));

  }

    window.limitPanelQuantity();
  });
